import { SelectField } from '~/shared/forms/controls/base-fields/SelectField';
import { AutocompleteSearchField } from '~/shared/forms/controls/base-fields/AutocompleteSearchField';
import { DatePickerField } from '~/shared/forms/controls/base-fields/DatePickerField';
import { useGetSchedulingOptions } from './useGetSchedulingOptions';
import { useQueryDataTableFilter } from '~/shared/data-tables/query/useQueryDataTableFilter';
import { convertClientDateToServerDate, convertUrlDateToClientDate } from '~/util/date';

export function WeekOfFilter() {
	const { data: options } = useGetSchedulingOptions();
	const [weekNumber, setWeekNumber] = useQueryDataTableFilter({
		name: 'weekNumber',
		convertFromQueryParam: value => value.toString()
	});

	return (
		<SelectField
			label="Week Of"
			hideLabel
			value={weekNumber}
			onChange={id => setWeekNumber(id)}
			items={options.weeks.map(x => ({
				id: x.weekNumber.toString(),
				name: `${x.startDate.toLocaleDateString()} to ${x.endDate.toLocaleDateString()}`
			}))}
		/>
	);
}

export function TeamFilter() {
	const { data: options } = useGetSchedulingOptions();
	const [team, setTeam] = useQueryDataTableFilter({
		name: 'team',
		convertFromQueryParam: value => value.toString()
	});
	return (
		<SelectField
			label="Team"
			hideLabel
			placeholder="All Teams"
			value={team}
			onChange={id => setTeam(id)}
			items={options?.teams.map(x => ({ id: x.id, name: x.label }))}
		/>
	);
}

export function PrimaryInsuranceFilter() {
	const [primaryInsurance, setPrimaryInsurance] = useQueryDataTableFilter({
		name: 'primaryInsurance',
		convertFromQueryParam: value => value,
		operator: '=='
	});
	return (
		<AutocompleteSearchField
			label="Insurance"
			hideLabel
			placeholder="All Insurances"
			searchType="schedule-report-primary-insurance"
			value={primaryInsurance}
			onChange={id => setPrimaryInsurance(id)}
		/>
	);
}

export function DisciplineFilter() {
	const { data: options } = useGetSchedulingOptions();
	const [discipline, setDiscpline] = useQueryDataTableFilter({
		name: 'discipline',
		convertFromQueryParam: value => value.toString()
	});
	return (
		<SelectField
			label="Discipline"
			hideLabel
			placeholder="All Disciplines"
			value={discipline}
			onChange={id => setDiscpline(id)}
			items={options?.disciplines.map(x => ({ id: x.id, name: x.label }))}
		/>
	);
}

export function AssignedToFilter() {
	const [assignedTo, setAssignedTo] = useQueryDataTableFilter({
		name: 'assignedTo',
		convertFromQueryParam: value => value.toString()
	});
	return (
		<AutocompleteSearchField
			label="Assigned To"
			hideLabel
			placeholder="All Users"
			searchType="schedule-report-assigned-to"
			value={assignedTo}
			onChange={id => setAssignedTo(id)}
		/>
	);
}

export function PatientFilter() {
	const [patient, setPatient] = useQueryDataTableFilter({
		name: 'patientCode',
		convertFromQueryParam: value => value.toString()
	});
	return (
		<AutocompleteSearchField
			label="Patient"
			hideLabel
			placeholder="All Patients"
			searchType="schedule-report-patient"
			value={patient}
			onChange={id => setPatient(id)}
		/>
	);
}

export function VisitDateFromFilter() {
	const [visitDateFrom, setVisitDateFrom] = useQueryDataTableFilter({
		name: 'visitDateFrom',
		convertFromQueryParam: value => convertUrlDateToClientDate(value),
		convertToQueryParam: value => convertClientDateToServerDate(value),
		operator: '>='
	});
	return <DatePickerField label="Visit Date From" hideLabel required value={visitDateFrom} onChange={setVisitDateFrom} />;
}

export function VisitDateToFilter() {
	const [visitDateTo, setVisitDateTo] = useQueryDataTableFilter({
		name: 'visitDateTo',
		convertFromQueryParam: value => convertUrlDateToClientDate(value),
		convertToQueryParam: value => convertClientDateToServerDate(value),
		operator: '<='
	});
	return <DatePickerField label="Visit Date To" hideLabel required value={visitDateTo} onChange={setVisitDateTo} />;
}
